import { render, staticRenderFns } from "./FormularioFichaSaude.vue?vue&type=template&id=f3a0c73a&"
import script from "./FormularioFichaSaude.vue?vue&type=script&lang=js&"
export * from "./FormularioFichaSaude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports